import React from "react";
import "./style.css";
import arrow from "../images/icon-arrow-down.svg";

const FaqAnswer = (props) => {
  return (
    <div className={props.class}>
      <div className="faq-question-container">
        <p className="faq-question">{props.question}</p>
        <img src={arrow} className="arrow-img" alt="" />
      </div>
      <div className="faq-answer-container">
        <p className="faq-answer">{props.answer}</p>
      </div>
    </div>
  );
};

export default FaqAnswer;
